<template>
  <!-- <div v-if="viewMode" v-html="formatNumber(value)"></div> -->
  <div>
    <q-input filled v-model="content" mask="time" :rules="['time']" v-if="quasar" dense>
      <template v-slot:append>
        <q-icon name="access_time" class="cursor-pointer">
          <q-popup-proxy cover transition-show="scale" transition-hide="scale">
            <q-time v-model="content" format24h>
              <div class="row items-center justify-end">
                <q-btn v-close-popup label="Close" color="primary" flat/>
              </div>
            </q-time>
          </q-popup-proxy>
        </q-icon>
      </template>
    </q-input>
    <input v-else
           ref="input"
           type="text"
           :class="'number-input '+(error?'time-error':'time-correct')"
           v-model="content"
           @keypress="filter"
           :disabled="disabled"
           :placeholder="placeholder"
    />
    <!-- <el-input-number
            v-model="formDada.bookedPrice"
            :controls="false"
            :precision="2"
            :step="0.01"
    ></el-input-number>-->
  </div>
</template>

<script>
export default {
  name: "s-time",
  props: {
    toInt: {default: false, type: Boolean},
    value: {default: null},
    quasar: {default: false, type: Boolean},
    placeholder: {type: String, default: "__.__"},

    disabled: {default: false, type: Boolean}
  },
  data() {
    return {
      initialValue: null,
      content: null,
      error: false
    };
  },
  created() {
    let val = this.value;
    if (val && !isNaN(val)) {
      val = this.intToTime(val);
    }

    this.content = val;
  },
  watch: {
    value(val, oldval) {
      if (val === oldval) return;
      _log_("val w.value.", val);
      if (val == this.content) return;
      if (val && !isNaN(val)) {
        val = this.intToTime(val);
      }
      if (val == this.content) return;
      this.content = val;
    },
    content: function (val, oldval) {
      if (val == this.value) return;
      {
        if (val.indexOf(".") >= 0) {
          val = val.replace(".", ":");
          // return;
        } else if (val.indexOf(":") < 0 && val.length > 2) {
          val = val.substring(0, 1) + ":" + val.substring(1, val.length);
        } else if (val.length > 4) {
          val = val.replace(":", "");
          const lst = val.substring(val.length - 2),
              frst = val.substring(val.length - 4, val.length - 2);
          val = frst + ":" + lst;
        }
        _log_("val w.CCC.", val);
        this.content = val;
        const valParts =
            val.indexOf(".") >= 0 ? val.split(".") : val.split(":");
        if (valParts[1] !== undefined) {
          if (parseInt(valParts[1]) < 60) this.error = false;
          else this.error = true;
          if (!this.error)
            if (parseInt(valParts[0]) < 24) this.error = false;
            else this.error = true;
        } else if (valParts[0] != undefined && parseInt(valParts[0]) < 60)
          this.error = false;
        else this.error = true;
        if (this.toInt) val = this.strTimeToInt(val);
        // if (!this.quasar)
        this.$emit('change', val);
        this.$emit("input", val);
      }
    }
  },
  methods: {
    init() {
    },
    filter(event) {
      _log_("k.." + event.keyCode);

      if (this.content && this.content.length > 4) return;
      if (event.keyCode == 13) {
        // this.$emit(
        //   "input",
        //   this.formatgreek ? this.content.replace(",", ".") : this.content
        // );
        return;
      }
      if (event.keyCode < 48 || event.keyCode > 57) {
        if (event.keyCode == 58 || event.keyCode == 46)
          if (this.content.indexOf(".") >= 0 || this.content.indexOf(":") >= 0)
            event.preventDefault();
        return;
      }

      // if (event.keyCode == 44) {
      //   if (this.formatgreek && (this.content + "").indexOf(",") > -1) {
      //     event.preventDefault();
      //     return;
      //   }
      // }
      // if (event.keyCode == 46) {
      //   if (!this.formatgreek && (this.content + "").indexOf(".") > -1) {
      //     event.preventDefault();
      //     return;
      //   }
      // }
      this.$emit("keypress", event);
    }
  }
};
</script>
<style>
.number-input {
  /* border-radius: 4px; */
  background-color: unset;
  border: none;
  text-align: right;
  width: 100%;
}

.number-input.time-correct {
  border-bottom: 1px solid #409eff;
}

.number-input.time-error {
  border-bottom: 1px solid #ff4040;
}
</style>

